module.exports = __webpack_public_path__ + "static/media/forgot-password-office-dark.6db046dc.jpeg";